export const statusMap = {
    "suggested": { title: "Suggéré", color: "bg-black/30" },
    "planned": { title: "Prévue", color: "bg-yellow-400" },
    "in progress": { title: "En cours", color: "bg-blue-400" },
    "achieved": { title: "Complété", color: "bg-green-500" }
};

export const typesMap = {
    "bugs": {
        cardText: "Bug",
        formText: "Signaler un bug"
    },
    "new-feature": {
        cardText: "Nouvelle fonctionnalité",
        formText: "Proposer une nouvelle fonctionnalité"
    },
    "improvement": {
        cardText: "Amélioration",
        formText: "Proposer une amélioration pour une fonctionnalité existante"
    }
}

export const categories = {
    "writing-ai": "Rédaction & IA Générative",
    "seo-analysis": "SEO & Analyse",
    "exports-integrations": "Export & Intégrations",
    "dashboard-ui": "Dashboard & Interface",
    "sites-content-management": "Sites & Gestion des Contenus",
    "automation-productivity": "Automatisation & Productivité",
    "support-docs": "Support & Documentation",
    "performances-and-internal-systems": "Performances & Systèmes internes"
}